import { render } from "./PageAuthor.vue?vue&type=template&id=e3cb46c8"
import script from "./PageAuthor.vue?vue&type=script&lang=js"
export * from "./PageAuthor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__